import { getApp } from 'firebase/app';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

export default function useNotifications() {
    async function requestPermission() {
        if (Capacitor.isNativePlatform()) {
            try {
                const token = await getTokenNative();
                return token;
            } catch (error) {
                throw new Error('Push notifications permission not granted');
            }
        } else {
            const token = await window.Notification.requestPermission()
                .then(async (permission: any) => {
                    if (permission == 'granted') {
                        const token = await getTokenWeb();
                        return token;
                    }
                })
                .catch((err) => {
                    throw err;
                });
            return token;
        }
    }
    async function getToken() {
        let token = null;
        try {
            if (Capacitor.isNativePlatform()) {
                token = await getTokenNative();
            } else {
                token = await getTokenWeb();
            }
        } catch (error) {
            console.error(error);
        }

        return token;
    }

    async function notificationsActive() {
        return !!window.Notification || Capacitor.isNativePlatform();
    }

    return {
        requestPermission,
        getToken,
        notificationsActive,
    };
}

async function getTokenWeb() {
    const app = getApp();
    const messaging = getMessaging(app);
    const token = await getToken(messaging, { vapidKey: import.meta.env.VITE_APP_FIREBASE_VAPID_KEY });
    return token;
}

async function getTokenNative() {
    const result = await PushNotifications.requestPermissions();
    if (!result || result.receive !== 'granted') return;

    PushNotifications.register();

    return new Promise((resolve, reject) => {
        PushNotifications.addListener('registration', (token: any) => {
            if (!token || !token.value) {
                reject(new Error('Push notifications registration failed'));
                return;
            }
            resolve(token.value);
        });
    });
}
